import { apiGet, apiPatch } from './client';
import type { Operator, OperatorBatchRequest } from '../types/Operator';

export function getOperators(): Promise<Operator[]> { return apiGet<Operator[]>('/api/operators'); }

export function saveBatchOperators(added: Operator[], modified: Operator[], deletedIds: number[]): Promise<Operator[]> {
  return apiPatch<OperatorBatchRequest, Operator[]>('/api/operators/batch', { added, modified, deleted: deletedIds });
}
